<template>
    <div class="indicator-data-container">
        <div class="text-right px-5">
            <div>
                <button
                    v-if="checkAuthorization('setting-kpi_create')"
                    class="create-group-btn"
                    @click="createGroup"
                >
                    THÊM NHÓM CHỈ SỐ
                    <v-icon>mdi-plus</v-icon>
                </button>
            </div>
        </div>
        <v-row>
            <v-col cols="12">
                <v-simple-table class="table-layout pa-5">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="table-header-group">Nhóm chỉ số</th>
                                <th class="table-header-indicator">Tên chỉ số</th>
                                <th class="table-header-unit">Đơn vị đo</th>
                                <th class="table-header-status">Status</th>
                            </tr>
                        </thead>
                        <template v-if="groups.length">
                            <tbody v-for="(group, index) in groups" :key="index">
                                <tr v-if="group.indicators.length">
                                    <td class="text-left" :rowspan="parseInt(group.indicators.length) + 1">
                                        {{ group.name }}
                                        <span class="group-actions">
                                            <span
                                                v-if="checkAuthorization('setting-kpi_update')"
                                                class="group-action"
                                                @click="updateGroup(group)"
                                            >
                                                Sửa
                                            </span>
                                            <span
                                                v-if="checkAuthorization('setting-kpi_update')
                                                  && checkAuthorization('setting-kpi_delete')"
                                            > | </span>
                                            <span
                                                v-if="checkAuthorization('setting-kpi_delete')"
                                                class="group-action"
                                                @click="deleteGroup(group)"
                                            >
                                                Xóa
                                            </span>
                                        </span>
                                    </td>
                                    <td class="text-left">
                                        {{ group.indicators[0] ? group.indicators[0].name : '' }}
                                        <span class="indicator-actions" v-if="group.indicators[0]">
                                            <span
                                                v-if="checkAuthorization('setting-kpi_update')"
                                                class="indicator-action"
                                                @click="updateIndicator(group.indicators[0])"
                                            >
                                                Sửa
                                            </span>
                                            <span
                                                v-if="checkAuthorization('setting-kpi_update')
                                                    && checkAuthorization('setting-kpi_delete')"
                                            > | </span>
                                            <span
                                                v-if="checkAuthorization('setting-kpi_delete')"
                                                class="indicator-action"
                                                @click="deleteIndicator(group.indicators[0])"
                                            >
                                                Xóa
                                            </span>
                                        </span>
                                    </td>
                                    <td class="text-left">{{ group.indicators[0] ? group.indicators[0].unitName : '' }}</td>
                                    <td class="text-left">{{ group.indicators[0] ? group.indicators[0].status : '' }}</td>
                                </tr>
                                <template v-else>
                                    <tr>
                                        <td class="text-left" :rowspan="2">
                                            {{ group.name }}
                                            <span class="group-actions">
                                                <span
                                                    v-if="checkAuthorization('setting-kpi_update')"
                                                    class="group-action"
                                                    @click="updateGroup(group)"
                                                >
                                                    Sửa
                                                </span>
                                                <span
                                                    v-if="checkAuthorization('setting-kpi_update')
                                                      && checkAuthorization('setting-kpi_delete')"
                                                > | </span>
                                                <span
                                                    v-if="checkAuthorization('setting-kpi_delete')"
                                                    class="group-action"
                                                    @click="deleteGroup(group)"
                                                >
                                                    Xóa
                                                </span>
                                            </span>
                                        </td>
                                        <td class="text-left">
                                            Không có dữ liệu
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        v-if="checkAuthorization('setting-kpi_create')"
                                        class="border-bottom">
                                        <td class="text-left">
                                            <button
                                                class="add-indicator-btn"
                                                title="Thêm chỉ số"
                                                @click="createIndicator(group)"
                                            >
                                                <v-icon>mdi-plus</v-icon>
                                            </button>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </template>
                                <template v-if="group.indicators.length > 1">
                                    <tr v-for="(indicator, indexIndi) in group.indicators.slice(1)" :key="'indicator' + indexIndi">
                                        <td class="text-left">
                                            {{ indicator.name }}
                                            <span class="indicator-actions">
                                                <span
                                                    v-if="checkAuthorization('setting-kpi_update')"
                                                    class="indicator-action"
                                                    @click="updateIndicator(indicator)"
                                                >
                                                    Sửa
                                                </span>
                                                <span
                                                    v-if="checkAuthorization('setting-kpi_update')
                                                        && checkAuthorization('setting-kpi_delete')"
                                                > | </span>
                                                <span
                                                    v-if="checkAuthorization('setting-kpi_delete')"
                                                    class="indicator-action"
                                                    @click="deleteIndicator(indicator)"
                                                >
                                                    Xóa
                                                </span>
                                            </span>
                                        </td>
                                        <td class="text-left">{{ indicator.unitName }}</td>
                                        <td class="text-left">{{ indicator.status }}</td>
                                    </tr>
                                </template>
                                <tr v-if="group.indicators.length && checkAuthorization('setting-kpi_create')"
                                    class='border-bottom'>
                                    <td class="text-left">
                                        <button
                                            class="add-indicator-btn"
                                            title="Thêm chỉ số"
                                            @click="createIndicator(group)"
                                        >
                                            <v-icon>mdi-plus</v-icon>
                                        </button>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </template>
                        <tbody v-else>
                            <tr>
                                <td colspan="1000">
                                    <common-no-result />
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>

        <indicator-group-form 
            :showCreateGroup="showCreateGroup"
            :isCreateGroup="isCreateGroup"
            :group="group"
            :allowAcceptGroup="allowAcceptGroup"
        />

        <indicator-form 
            :showCreateIndicator="showCreateIndicator"
            :isCreateIndicator="isCreateIndicator"
            :indicator="indicator"
            :groupList="groupList"
            :allowAcceptIndicator="allowAcceptIndicator"
        />
    </div>
</template>

<script>
import IndicatorGroupForm from './IndicatorGroupForm'
import IndicatorForm from './IndicatorForm'
import RepositoryFactory from '@/repositories/RepositoryFactory'
const IndicatorRepository = RepositoryFactory.get('indicator')

export default {
    props: {
        groups: {
            type: Array,
            default: () => {[]}
        },
        groupList: {
            type: Array,
            default: () => {[]}
        }
    },

    components: {
        IndicatorGroupForm,
        IndicatorForm
    },
    
    data() {
        return {
            showCreateGroup: false,
            allowAcceptGroup: true,
            showCreateIndicator: false,
            allowAcceptIndicator: true,
            group: {
                name: ''
            },
            indicator: {
                name: '',
                groupId: '',
                unitName: '',
                status: ''
            },
            isCreateGroup: true,
            isCreateIndicator: true
        }
    },

    created() {
        Bus.$on('close-group-create-modal', () => {
            this.showCreateGroup = false
        })

        Bus.$on('close-indicator-create-modal', () => {
            this.showCreateIndicator = false
        })

        Bus.$on('save-indicator-group', group => {
            this.saveGroup(group)
        })

        Bus.$on('save-indicator', indicator => {
            this.saveIndicator(indicator)
        })

        Bus.$on('action-save-group', () => {
            this.allowAcceptGroup = false
        })

        Bus.$on('action-save-indicator', () => {
            this.allowAcceptIndicator = false
        })
    },

    beforeDestroy() {
        Bus.$off('close-group-create-modal')
        Bus.$off('close-indicator-create-modal')
        Bus.$off('save-indicator-group')
        Bus.$off('save-indicator')
        Bus.$off('action-save-group')
        Bus.$off('action-save-indicator')
    },

    methods: {
        createGroup() {
            this.group = {name: ''}
            this.isCreateGroup = true
            this.showCreateGroup = true
        },

        updateGroup(group) {
            this.group = _.cloneDeep(group)
            this.isCreateGroup = false
            this.showCreateGroup = true
        },

        createIndicator(group) {
            this.indicator = {
                name: '',
                groupId: group.id,
                unitName: '',
                status: ''
            }
            this.isCreateIndicator = true
            this.showCreateIndicator = true
        },

        updateIndicator(indicator) {
            this.indicator = _.cloneDeep(indicator)
            this.isCreateIndicator = false
            this.showCreateIndicator = true
        },

        async saveGroup(group) {
            const data = {
                name: group.name.trim()
            }

            if (this.isCreateGroup) {
                const res = await IndicatorRepository.createGroup(data)

                if (res.success) {
                    this.showCreateGroup = false
                    this.allowAcceptGroup = true
                    this.$swal({
                        title: 'Cập nhật dữ liệu thành công',
                        timer: 1000
                    })
                    Bus.$emit('search-indicator-group-list')
                } else {
                    this.allowAcceptGroup = true
                    this.$swal({
                        title: 'Lỗi!',
                        text: _.get(res, 'message', '')
                    })
                }
            } else {
                const res = await IndicatorRepository.updateGroup(group.id, data)

                if (res.success) {
                    this.showCreateGroup = false
                    this.allowAcceptGroup = true
                    this.$swal({
                        title: 'Cập nhật dữ liệu thành công',
                        timer: 1000
                    })
                    Bus.$emit('search-indicator-group-list')
                } else {
                    this.allowAcceptGroup = true
                    this.$swal({
                        title: 'Lỗi!',
                        text: _.get(res, 'message', '')
                    })
                }
            }
        },

        async saveIndicator(indicator) {
            const data = {
                name: indicator.name,
                groupId: indicator.groupId,
                unitName: indicator.unitName,
                status: indicator.status
            }

            if (this.isCreateIndicator) {
                const res = await IndicatorRepository.create(data)

                if (res.success) {
                    this.showCreateIndicator = false
                    this.allowAcceptIndicator = true
                    this.$swal({
                        title: 'Cập nhật dữ liệu thành công',
                        timer: 1000
                    })
                    Bus.$emit('search-indicator-group-list')
                } else {
                    this.allowAcceptIndicator = true
                    this.$swal({
                        title: 'Lỗi!',
                        text: _.get(res, 'message', '')
                    })
                }
            } else {
                const res = await IndicatorRepository.update(indicator.id, data)

                if (res.success) {
                    this.showCreateIndicator = false
                    this.allowAcceptIndicator = true
                    this.$swal({
                        title: 'Cập nhật dữ liệu thành công',
                        timer: 1000
                    })
                    Bus.$emit('search-indicator-group-list')
                } else {
                    this.allowAcceptIndicator = true
                    this.$swal({
                        title: 'Lỗi!',
                        text: _.get(res, 'message', '')
                    })
                }
            }
        },

        async deleteGroup(group) {
            this.$swal({
                title: 'Bạn có chắc muốn xóa nhóm chỉ số?',
                showCancelButton: true,
                cancelButtonText: 'Bỏ qua'
            }).then(async response => {
                if (response.value) {
                    const res = await IndicatorRepository.deleteGroup(group.id)

                    if (res.success) {
                        this.$swal({
                            title: 'Cập nhật dữ liệu thành công',
                            timer: 1000
                        })
                        Bus.$emit('search-indicator-group-list')
                    } else {
                        this.$swal({
                            title: 'Lỗi!',
                            text: _.get(res, 'message', '')
                        })
                    }
                }
            })
        },

        async deleteIndicator(indicator) {
            this.$swal({
                title: 'Bạn có chắc muốn xóa chỉ số?',
                showCancelButton: true,
                cancelButtonText: 'Bỏ qua'
            }).then(async response => {
                if (response.value) {
                    const res = await IndicatorRepository.delete(indicator.id)

                    if (res.success) {
                        this.$swal({
                            title: 'Cập nhật dữ liệu thành công',
                            timer: 1000
                        })
                        Bus.$emit('search-indicator-group-list')
                    } else {
                        this.$swal({
                            title: 'Lỗi!',
                            text: _.get(res, 'message', '')
                        })
                    }
                }
            })
        },
    }
}
</script>

<style scoped>
.indicator-data-container {
    padding-top: 10px;
}

.create-group-btn {
    padding: 5px 8px;
    border: 1px solid black;
    font-size: 14px;
    font-weight: 400;
    border-radius: 8px;
}

.create-group-btn i {
    color: black !important;
}

/deep/ .v-data-table td {
    border-left: thin solid rgba(0, 0, 0, 0.12) !important;
    border-right: thin solid rgba(0, 0, 0, 0.12) !important;
    border-bottom: none !important;
    font-weight: 400;
    font-size: 16px;
    word-break: break-word;
}

/deep/ .v-data-table td i {
    color: black;
}

/deep/ .v-data-table tbody:last-child tr:first-child td:first-child {
    border-bottom-left-radius: 10px;
}

/deep/ .v-data-table tbody:last-child tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
}

/deep/ .v-data-table th {
    font-weight: bold !important;
    font-size: 20px !important;
    border-left: thin solid rgba(0, 0, 0, 0.12) !important;
    border-right: thin solid rgba(0, 0, 0, 0.12) !important;
    border-top: thin solid rgba(0, 0, 0, 0.12) !important;
    background: #F3F2F9;
}

/deep/ .v-data-table th:first-child {
    border-top-left-radius: 10px;
}

/deep/ .v-data-table th:last-child {
    border-top-right-radius: 10px;
}

/deep/ .v-data-table th.table-header-group, .v-data-table th.table-header-indicator {
    width: 35%;
}

/deep/ .v-data-table th.table-header-unit, .v-data-table th.table-header-status {
    width: 15%;
}

/deep/ .table-layout tbody tr.border-bottom td {
    border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

/deep/ .table-layout tbody tr td[rowspan] {
    border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

/deep/ .table-layout tbody tr {
    height: 60px !important;
}

/deep/ tbody:hover td[rowspan], tr:hover td {
   background: #DDDDDD; 
}

/deep/ tbody:hover .group-actions {
    display: inline-block;
}

/deep/ .v-data-table tr:hover .indicator-actions {
    display: inline-block;
}

.add-indicator-btn {
    border: 0.462185px dashed #BDBDBD;
    padding: 3px 5px;
    border-radius: 50%;
    cursor: pointer;
    width: 32px;
    height: 32px;
}

.group-actions, .indicator-actions {
    display: none;
}

.group-action, .indicator-action {
    color: #2F80ED;
    font-weight: 300;
    cursor: pointer;
    font-size: 12px;
}

.group-action:hover, .indicator-action:hover {
    text-decoration: underline;
    text-underline-position: below;
}
</style>